import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import VideoPlayer from '@/components/VideoPlayer.vue'
  import useVideo from '@/composables/useVideo'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import type { PropType } from 'vue'
  import type { CompanyOnboardingPopupDetails } from '@/services/interfaces/Auth0'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyOnboardingModal',
  props: {
    onboardingPopupDetails: {
      type: Object as PropType<CompanyOnboardingPopupDetails>,
      required: true,
    },
  },
  emits: ['close'],
  setup(__props) {

const props = __props;

  
  

  const { getPosterImage } = useVideo()

  const popupPosterImage = computed(() => {
    return (
      props.onboardingPopupDetails?.posterImageUrl ??
      getPosterImage(
        props.onboardingPopupDetails.videoUrl,
        props.onboardingPopupDetails.timestamp ? props.onboardingPopupDetails.timestamp : 0,
      )
    )
  })

return { __sfc: true,props, getPosterImage, popupPosterImage, computed, VideoPlayer, useVideo, KetchUpButton, HTMLRenderer }
}

})